import LockIcon from '@mui/icons-material/Lock'
import React from 'react'
import styled from 'styled-components'
import { Tooltip } from 'sutra/components/Tooltip/Tooltip'
import { gray } from 'sutra/tokens/colors'

import { EditGlobalFiltersLink } from 'components/EditGlobalFiltersLink'

const MESSAGE = 'Cannot change a global filter here.'

export interface InheritedFilterBadgeProps {
  /** Focuses the dashboard's Global filters panel. Renders the tooltip's
   *  "Edit global filters" as a clickable link when present, plain text
   *  otherwise — see `EditGlobalFiltersLink`'s doc comment. */
  onEditSource?: () => void
}

/**
 * Lock chip marking a filter card as inherited from a parent scope (a
 * dashboard's global filters) rather than owned by the tile. The card still
 * shows an eye/✕ on hover, like an owned card, but they're inert there —
 * they only point at where the filter is actually removable (see
 * `FilterCard`'s `inherited.onEditSource` doc comment).
 *
 * The tooltip's message is always the same fixed sentence, deliberately —
 * it used to vary (a generic default, or the card's own `supersededNote`
 * verbatim), which read as inconsistent across cards. One sentence, always.
 */
export const InheritedFilterBadge: React.FC<InheritedFilterBadgeProps> = ({
  onEditSource,
}) => {
  return (
    <Tooltip
      content={
        <>
          {MESSAGE} <EditGlobalFiltersLink onClick={onEditSource} />
        </>
      }
    >
      <Badge aria-label={MESSAGE}>
        <LockIcon style={{ fontSize: '13px' }} />
      </Badge>
    </Tooltip>
  )
}

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: ${gray[500]};
  flex-shrink: 0;
`
